import { apiClient } from './api-client';
import { Notification, CreateNotificationRequest, NotificationPreferences, BulkNotificationRequest } from '../types';

export class NotificationService {
  // Get notifications for current user/member
  async getNotifications(
    filters?: { 
      isRead?: boolean; 
      priority?: string; 
      type?: string; 
      limit?: number; 
    }
  ): Promise<Notification[]> {
    const params = new URLSearchParams();
    if (filters?.isRead !== undefined) params.append('isRead', filters.isRead.toString());
    if (filters?.priority) params.append('priority', filters.priority);
    if (filters?.type) params.append('type', filters.type);
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const response = await apiClient.get(`/api/notifications?${params}`);
    return response.success ? response.data : [];
  }

  // Get unread notification count for current user/member
  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get('/api/notifications/unread-count');
    return response.success ? response.data.count : 0;
  }

  // Mark notification as read
  async markAsRead(notificationId: string): Promise<boolean> {
    const response = await apiClient.put(`/api/notifications/${notificationId}/read`);
    return response.success;
  }

  // Mark all notifications as read
  async markAllAsRead(): Promise<boolean> {
    const response = await apiClient.put('/api/notifications/mark-all-read');
    return response.success;
  }

  // Create notification (admin only)
  async createNotification(notification: CreateNotificationRequest): Promise<boolean> {
    const response = await apiClient.post('/api/notifications', notification);
    return response.success;
  }

  // Send bulk notifications (admin only)
  async sendBulkNotifications(request: BulkNotificationRequest): Promise<boolean> {
    const response = await apiClient.post('/api/notifications/bulk', request);
    return response.success;
  }

  // Get notification preferences
  async getPreferences(): Promise<NotificationPreferences | null> {
    const response = await apiClient.get('/api/notifications/preferences');
    return response.success ? response.data : null;
  }

  // Update notification preferences
  async updatePreferences(preferences: Partial<NotificationPreferences>): Promise<boolean> {
    const response = await apiClient.put('/api/notifications/preferences', preferences);
    return response.success;
  }

  // Delete expired notifications (admin only)
  async cleanupExpired(): Promise<boolean> {
    const response = await apiClient.delete('/api/notifications/cleanup');
    return response.success;
  }
}

export const notificationService = new NotificationService();